'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var embedlyTagIncluded = false;

exports.default = {
    props: ['url', 'component', 'isIframe', 'showPin'],
    data: function data() {
        return {};
    },
    computed: {
        embedlyKey: function embedlyKey() {
            return _state2.default.settings.embedly.key;
        }
    },
    watch: {
        url: function watchUrl() {
            this.updateEmbed();
        },
        isIframe: function watchUrl() {
            this.updateEmbed();
        }
    },
    created: function created() {
        this.updateEmbed();
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            _state2.default.$emit('mediaviewer.opened');
        });
    },
    methods: {
        updateEmbed: function updateEmbed() {
            var _this = this;

            var checkEmbedlyAndShowCard = function checkEmbedlyAndShowCard() {
                if (_this.isIframe) {
                    return;
                }

                if (typeof window.embedly !== 'function') {
                    setTimeout(checkEmbedlyAndShowCard, 100);
                    return;
                }
                _this.$nextTick(function () {
                    window.embedly('card', _this.$refs.embedlyLink);
                });
            };

            if (!embedlyTagIncluded) {
                var head = document.getElementsByTagName('head')[0];
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = '//cdn.embedly.com/widgets/platform.js';
                head.appendChild(script);
                embedlyTagIncluded = true;
            }
            checkEmbedlyAndShowCard();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MediaViewer"]
window._kiwi_exports.components.MediaViewer = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MediaViewer.vue
// module id = hfYN
// module chunks = 1